var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('main', {
    ref: "coordinatorBox",
    staticClass: "clearfix warp-content"
  }, [_c('div', {
    staticClass: "contentBox"
  }, [_c('div', {
    staticClass: "contentLeft"
  }, [_c('div', {
    staticClass: "mute-container"
  }), _vm.showPage ? _c('div', {
    staticClass: "videoContent"
  }, [_vm.userInfo.role == 2 || _vm.userInfo.role == 3 || _vm.userInfo.role == 5 ? _c('reporterAndQuestioner', {
    ref: "reporter",
    attrs: {
      "MeInfo": _vm.MeInfo,
      "talkInfo": _vm.talkInfo,
      "userInfo": _vm.userInfo,
      "channel": _vm.channels,
      "joinPartyCode": _vm.joinPartyCode,
      "shareInfo": _vm.shareInfo,
      "degreeHost": _vm.degreeHost,
      "lockName": _vm.lockName,
      "liveInfo": _vm.rtilStatusObj,
      "rtc": _vm.rtc,
      "isAudioLevel": _vm.isAudioLevel,
      "showRightAside": _vm.showRightAside
    },
    on: {
      "dealHasUnsubscribe": _vm.dealHasUnsubscribes,
      "dealReporterShareHasUnsubscribe": _vm.dealReporterShareHasUnsubscribe,
      "callback": _vm.attendCallback
    }
  }) : _vm._e(), _vm.userInfo.role == 4 ? _c('Speaker', {
    ref: "speakerBox",
    attrs: {
      "MeInfo": _vm.MeInfo,
      "talkInfo": _vm.talkInfo,
      "userInfo": _vm.userInfo,
      "channel": _vm.channels,
      "muteVideoMe": !_vm.State.cameraStatus[_vm.talkInfo.rtilCode],
      "muteAudioMe": !_vm.State.micStatus[_vm.talkInfo.rtilCode],
      "shareInfo": _vm.shareInfo,
      "degreeHost": _vm.degreeHost,
      "showRightAside": _vm.showRightAside,
      "rtc": _vm.rtc,
      "liveInfo": _vm.rtilStatusObj,
      "lockName": _vm.lockName,
      "isAudioLevel": _vm.isAudioLevel
    },
    on: {
      "exSubscribeTrack": _vm.subscribeTrack,
      "dealSpeakHasUnsubscribe": _vm.dealSpeakHasUnsubscribe,
      "dealSpeakShareHasUnsubscribe": _vm.dealSpeakShareHasUnsubscribe,
      "callback": _vm.attendCallback
    }
  }) : _vm._e()], 1) : _vm._e()]), _vm.userInfo.rtilCode ? _c('div', {
    staticClass: "contentRight",
    class: {
      active: _vm.showRightAside,
      notShowFootBar: !_vm.State.showFootBar,
      fullScreen: _vm.State.fullScreen
    }
  }, [_c('ChatMessage', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showRightAside,
      expression: "showRightAside"
    }],
    attrs: {
      "userInfo": _vm.userInfo,
      "showComponent": _vm.showRightAside,
      "allPartyMembers": _vm.allPartyMembers,
      "chatPartyCode": _vm.userInfo.realPartyCode,
      "nickNameInfo": _vm.nickNameInfo,
      "organizationInfo": _vm.organizationInfo
    },
    on: {
      "callback": _vm.chatCallback
    }
  })], 1) : _vm._e()]), _vm.userInfo.rtilCode ? _c('Foot', {
    attrs: {
      "camera": _vm.State.cameraStatus[_vm.userInfo.rtilCode],
      "mic": _vm.State.micStatus[_vm.userInfo.rtilCode],
      "rtcLoaded": _vm.rtcLoaded,
      "isShare": _vm.isShare,
      "userInfo": _vm.userInfo,
      "showUnread": _vm.showUnread,
      "devicesInfo": _vm.devicesInfo,
      "hasSetRaiseHand": _vm.hasSetRaiseHand,
      "cameraDevice": _vm.devicesInfo.cameraList,
      "speakerDevice": _vm.devicesInfo.speakerList,
      "showIconArray": _vm.operationList,
      "localVolume": _vm.localVolume,
      "rtc": _vm.rtc,
      "microphoneDevice": _vm.devicesInfo.microphoneList
    },
    on: {
      "eventCallback": _vm.dealFootEvent
    }
  }) : _vm._e(), _vm.setNameInfo.show ? _c('user-setting', {
    attrs: {
      "info": _vm.setNameInfo
    },
    on: {
      "setNickName": _vm.setNickName
    }
  }) : _vm._e(), _c('TipsDailog', {
    attrs: {
      "info": _vm.CameraTips,
      "showClose": false
    },
    on: {
      "save": _vm.setCameraStatus,
      "cancel": _vm.sendToHost
    }
  }), _c('tipsDailog', {
    staticClass: "collaboratePopup",
    attrs: {
      "info": _vm.collaborateInfo,
      "width": "640px"
    },
    on: {
      "save": function ($event) {
        return _vm.controlInvite(true);
      },
      "cancel": function ($event) {
        return _vm.controlInvite(false);
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('img', {
    attrs: {
      "src": "https://dl.tvunetworks.com/static/partyline/image/people.png"
    }
  }), _c('span', [_vm._v(_vm._s(_vm.$t('personalInfo.account')) + " " + _vm._s(_vm.collaborateInfo.info.fromEmail) + " " + _vm._s(_vm.$t('personalInfo.collaboratePopupLike')))])]), _c('div', {
    staticClass: "popupContent"
  }, [_c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupAllow')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail1')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail2')))]), _c('p', [_vm._v(_vm._s(_vm.$t('personalInfo.collaboratePopupDetail3')))])])])]), _c('tipsDailog', {
    staticClass: "repeatJoin",
    attrs: {
      "width": "550px",
      "info": _vm.repeatInfo
    },
    on: {
      "save": function ($event) {
        _vm.repeatInfo.show = false;
      }
    }
  }, [_c('div', {
    staticClass: "email"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('common.repeatContent')))])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };